import { useLocation } from "react-router-dom";
import { ActionPath } from "../../../utility/types/common";

export const useActionPath = () => {
  const { pathname } = useLocation();

  // this code is taking `upload-documents-rtw` from  http://localhost:3000/checklist/tasks/upload-documents-rtw/JOB-UK-000000000/000-000-000
  const getActionPath = pathname.split("/")[3];

  return getActionPath as ActionPath;
};
